import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { NavLink } from 'react-router-dom';
import axios from '../../../axios/axios';
import { translateStaticContent } from '../../../helpers/translateStaticContent';
import SocialNetworksItem from './SocialNetworksItem';

class Footer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            socialNetworks: [],
        };
    }

    componentDidMount() {
        axios.post(`/api/welsend/public/exchangeRates`, ['USD'])
        .then(res => res.data)
        .then(rates => {
            this.setState({...this.state,  USD: rates[0].rate})  
        })
        .catch((error =>  {
            console.log(error);
        }))

        axios.post(`/api/welsend/public/exchangeRates`, ['EUR'])
        .then(res => res.data)
        .then(rates => {
            this.setState({...this.state,  EUR: rates[0].rate})
        })
        .catch((error =>  {
            console.log(error);
        }))

        // axios.post(`/api/welsend/public/exchangeRates`, ['RUB'])
        // .then(res => res.data)
        // .then(rates => {
        //     this.setState({...this.state,  RUB: rates[0].rate})
        // })
        // .catch((error =>  {
        //     console.log(error);
        // }))

        axios.get(`api/welsend/public/socialNetworks/info`)
        .then(res => {
            this.setState({...this.state, socialNetworks: res.data.slice(0, 4)})
        })
        .catch((error =>  {
            console.log(error);
        }))
    }

    socialNetworks = () => {
        let socialNetworksList = [];
        if(this.state.socialNetworks.length > 0) {
            socialNetworksList = this.state.socialNetworks.map(net => {
                return <SocialNetworksItem id={net.id} link={net.link} key={net.id}/>
            })
        }
        return socialNetworksList;
    }

    render() {
        return(
            <div className='footer-wrapper'>
               <div className="footer">
                   <div className="logo">
                       <NavLink to='/' rel="noreferrer"><img src={'api/welsend/public/siteLogo/file'} referrerPolicy="no-referrer"  
                        alt="welsend_logo"/></NavLink>
                   </div>
                   <div className="nav">
                       <div className="inner-menu">
                           <div className="menu-header">
                                {translateStaticContent('transfers', 
                                this.props.defaultStaticContentNav, this.props.activeLangStaticContentNav)}
                            </div>
                           <NavLink to={{
                               pathname: '/transferState',
                               hash: '#transferState',
                               state: {
                                getTransferInfo: false }
                               }} rel="noreferrer">
                                {translateStaticContent('transferInfo', 
                                this.props.defaultStaticContentNav, this.props.activeLangStaticContentNav)}
                            </NavLink>
                           <NavLink to={{
                               pathname: '/transferState',
                               hash: '#getTransferInfo',
                               state: {
                                getTransferInfo: true }
                            }} rel="noreferrer">
                                {translateStaticContent('transferState', 
                                this.props.defaultStaticContentNav, this.props.activeLangStaticContentNav)}
                            </NavLink>
                           <NavLink to={{
                               pathname: '/calculator',
                               hash: '#howToSend',
                               state: {
                                 howToSend: true }
                               }} rel="noreferrer">
                                {translateStaticContent('transferSend', 
                                this.props.defaultStaticContentNav, this.props.activeLangStaticContentNav)}
                            </NavLink>
                           <NavLink to={{
                               pathname: '/calculator',
                               hash: '#calculate',
                               state: {
                                 howToSend: false }
                               }} rel="noreferrer">
                                {translateStaticContent('transferCount', 
                                this.props.defaultStaticContentNav, this.props.activeLangStaticContentNav)}
                            </NavLink>
                       </div>
                       <div className="inner-menu">
                           <div className="menu-header">
                                {translateStaticContent('footerInfo', 
                                this.props.defaultStaticContentNav, this.props.activeLangStaticContentNav)}
                            </div>
                           <NavLink to='/maps' rel="noreferrer">
                                {translateStaticContent('points', 
                                this.props.defaultStaticContentNav, this.props.activeLangStaticContentNav)}
                            </NavLink>
                           <NavLink to='/faqs' rel="noreferrer">
                                {translateStaticContent('faqs', 
                                this.props.defaultStaticContentNav, this.props.activeLangStaticContentNav)}
                           </NavLink>
                           <NavLink to='/aboutSystem' rel="noreferrer">
                                {translateStaticContent('aboutSystem', 
                                this.props.defaultStaticContentNav, this.props.activeLangStaticContentNav)}
                           </NavLink>
                           <NavLink to='/tariffs' rel="noreferrer">
                               {translateStaticContent('tariffs', 
                               this.props.defaultStaticContentNav, this.props.activeLangStaticContentNav)}
                            </NavLink>
                       </div> 
                       <div className="inner-menu" rel="noreferrer">
                           <div className="menu-header">
                                {translateStaticContent('footerForPartners', 
                                this.props.defaultStaticContentNav, this.props.activeLangStaticContentNav)}
                           </div>
                           <NavLink to={{
                               pathname: '/partners',
                               hash: '#partner',
                               state: {
                                   toBePartner: false }
                               }} rel="noreferrer">
                                   {translateStaticContent('partners', 
                                   this.props.defaultStaticContentNav, this.props.activeLangStaticContentNav)}
                            </NavLink>
                           <NavLink to={{
                               pathname: '/partners',
                               hash: '#toBePartner',
                               state: {
                                   toBePartner: true  
                               }
                               }} rel="noreferrer">
                                   {translateStaticContent('bePartner', 
                                   this.props.defaultStaticContentNav, this.props.activeLangStaticContentNav)}
                            </NavLink>
                       </div>    
                   </div>
                   <div className="rates">
                       <div className="rates-header">
                            {translateStaticContent('exchangeRates', 
                            this.props.defaultStaticContentNav, this.props.activeLangStaticContentNav)}
                       </div>
                        <div className="rate"><span className="usd"></span>USD<span>{this.state.USD}</span></div>
                       <div className="rate"><span className="eur"></span>EUR<span>{this.state.EUR}</span></div>
                       {/* <div className="rate"><span className="rub"></span>RUB<span>{this.state.RUB}</span></div> */}
                   </div>
                   <div className="info">
                       <div className="logo">
                           <NavLink to='/' rel="noreferrer"><img src={'api/welsend/public/siteLogo/file'} referrerPolicy="no-referrer"
                            alt="welsend_logo"/></NavLink>
                       </div>
                       <div className="phone">
                           <div>
                                {translateStaticContent('shortPhoneNumberLabel', 
                                    this.props.defaultStaticContent, this.props.activeLangStaticContent)}
                                <span>{translateStaticContent('phoneTextLabel', 
                                    this.props.defaultStaticContent, this.props.activeLangStaticContent)}
                                </span>
                            </div>
                           <div>{translateStaticContent('firstPhoneNumberLabel', 
                                    this.props.defaultStaticContent, this.props.activeLangStaticContent)}</div>
                           <div>{translateStaticContent('secondPhoneNumberLabel', 
                                    this.props.defaultStaticContent, this.props.activeLangStaticContent)}</div>
                       </div>
                       <div className="social">
                           {this.socialNetworks()}
                       </div>
                       <div className="address">
                            {translateStaticContent('legalAddressLabel', 
                            this.props.defaultStaticContent, this.props.activeLangStaticContent)}:&nbsp;
                            <span>
                                {translateStaticContent('legalAddress', 
                                this.props.defaultStaticContent, this.props.activeLangStaticContent)}
                            </span>
                            <br/>
                             {translateStaticContent('mailingAddressLabel', 
                             this.props.defaultStaticContent, this.props.activeLangStaticContent)}:&nbsp;
                            <span>
                                {translateStaticContent('mailingAddress', 
                                this.props.defaultStaticContent, this.props.activeLangStaticContent)}
                            </span>
                        </div>
                   </div>
               </div>
                <div className="bottom">
                   <div>
                       {translateStaticContent('license', 
                       this.props.defaultStaticContent, this.props.activeLangStaticContent)}<br/>
                       {translateStaticContent('certificate', 
                       this.props.defaultStaticContent, this.props.activeLangStaticContent)}
                   </div>    
                   <div className="copyright">{copyrightDate()}</div>
               </div>
             </div>
           )
    }
}

export default Footer;

Footer.propTypes = {
    defaultStaticContent: PropTypes.object,
    activeLangStaticContent: PropTypes.object,
    defaultStaticContentNav: PropTypes.object,
    activeLangStaticContentNav: PropTypes.object,
  }

const copyrightDate = () => {
    const date = new Date();
    const year = date.getFullYear();
    const copyright = `© 2001-${year} АБ «УКРГАЗБАНК»`;
    return copyright;
}